<template>
  <div>
    <b-row class="mb-3">
      <!-- Export -->
      <b-col sm="12" class="d-flex align-items-center" v-if="$can('disbursement_log')">
        <b-button
          variant="success"
          class="my-2 mr-3"
          :disabled="isLoadingButton || !isParams"
          @click="handleExport"
        >
          <div class="d-inline-flex sk-three-bounce custom-loading-bounce" v-if="isLoadingButton">
            <div class="sk-child sk-bounce1"></div>
            <div class="sk-child sk-bounce2"></div>
            <div class="sk-child sk-bounce3"></div>
          </div>
          <span v-else>Export</span>
        </b-button>
      </b-col>
      <!-- Transaction Type -->
      <b-col sm="6">
        <b-form-group class="mb-3" label="Transaction Type :" label-for="transaction-type">
          <b-form-select id="transaction-type" v-model="type" :options="transactionTypeOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <!-- Notify Date -->
      <b-col sm="6">
        <b-form-group
          class="mb-3"
          label="Notify Date :"
          label-for="notify-date"
          :state="dateRangeState"
        >
          <template #invalid-feedback>{{ dateRangeError }}</template>
          <b-input-group>
            <b-input-group-prepend is-text>
              <i class="fa fa-calendar"></i>
            </b-input-group-prepend>
            <range-picker
              id="notify-date"
              :start="notifyStartDate"
              :end="notifyEndDate"
              :type="'clear'"
              :disable="false"
              :autoUpdate="false"
              :timePicker="true"
              @picker="doNotifyDateFilter"
            ></range-picker>
            <b-input-group-append>
              <b-button type="button" variant="secondary" @click="resetNotifyDateFilter">Reset</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col sm>
        <b-button
          :disabled="stateButton"
          :style="buttonStyle"
          class="mb-2"
          @click="doFilter"
        >
          Apply Filter
        </b-button>
        <p class="mb-3" :style="{ color: 'rgba(115, 129, 143, 1)' }">
          Click button 'Apply Filter' to apply the filter
        </p>
      </b-col>
    </b-row>
    <!-- Skeleton Table -->
    <div v-if="isLoadingTable">
      <b-skeleton-table
        :rows="10"
        :columns="7"
        :table-props="{ bordered: true }"
      ></b-skeleton-table>
    </div>
    <!-- Vuetable -->
    <vuetable
      v-else
      ref="vuetable"
      :api-mode="false"
      :fields="fields"
      :per-page="limit"
      :data-manager="dataManager"
      pagination-path="pagination"
      :no-data-template="isParams ? defaultTemplate : noDataTemplate"
      :css="tableCss"
      :sort-order="sortOrder"
    >
      <template slot="transaction_date-slot" slot-scope="prop">
        <span>{{ prop.rowData.created_at || '-' }}</span>
      </template>
      <template slot="transaction_type-slot" slot-scope="prop">
        <span>{{ prop.rowData.transaction_type || '-' }}</span>
      </template>
      <template slot="notify_date-slot" slot-scope="prop">
        <span>{{ prop.rowData.notify_date || '-' }}</span>
      </template>
      <template slot="invoice_number-slot" slot-scope="prop">
        <span>{{ prop.rowData.invoice_number || '-' }}</span>
      </template>
      <template slot="service-slot" slot-scope="prop">
        <span>{{ prop.rowData.service || '-' }}</span>
      </template>
      <template slot="status-slot" slot-scope="prop">
        <span :style="{ color: statusColor(prop.rowData.status_name), fontWeight: '600' }">{{ prop.rowData.status_name || '-' }}</span>
      </template>
      <template slot="actions-slot" slot-scope="prop">
        <div class="custom-actions">
          <button class="btn btn-primary" @click="onAction('detail-item', prop.rowData)">
            Log Detail
          </button>
        </div>
      </template>
    </vuetable>
    <!-- Detail Modal -->
    <b-modal id="modal-detail-disbursement" size="lg" hide-footer centered header-class="disbursement-modal-header">
      <template #modal-title>
        <div class="d-flex align-items-center">
          <strong style="font-size: 16px;">Log Detail</strong>
          <span class="font-weight-normal text-muted" style="font-size: 13px; margin-left: 8px;"> &mdash; {{ selectedInvoiceNumber }}</span>
        </div>
      </template>
      <div v-if="isLoadingDetail" class="text-center py-4">
        <div class="sk-three-bounce d-inline-flex">
          <div class="sk-child sk-bounce1"></div>
          <div class="sk-child sk-bounce2"></div>
          <div class="sk-child sk-bounce3"></div>
        </div>
      </div>
      <div v-else>
        <b-card no-body class="mb-3">
          <b-card-header header-tag="header" class="p-0">
            <b-button block variant="light" class="text-left px-3 py-2 d-flex justify-content-between align-items-center" @click="accordionRequest = !accordionRequest">
              <span>Request</span>
              <i :class="accordionRequest ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
            </b-button>
          </b-card-header>
          <b-collapse :visible="accordionRequest">
            <b-card-body class="p-3">
              <pre class="mb-0 bg-light rounded p-2" style="font-size: 12px; max-height: 250px; overflow-y: auto; white-space: pre-wrap;">{{ parseJson(selectedDetail.request) }}</pre>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-3">
          <b-card-header header-tag="header" class="p-0">
            <b-button block variant="light" class="text-left px-3 py-2 d-flex justify-content-between align-items-center" @click="accordionResponse = !accordionResponse">
              <span>Response</span>
              <i :class="accordionResponse ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
            </b-button>
          </b-card-header>
          <b-collapse :visible="accordionResponse">
            <b-card-body class="p-3">
              <pre class="mb-0 bg-light rounded p-2" style="font-size: 12px; max-height: 250px; overflow-y: auto; white-space: pre-wrap;">{{ parseJson(selectedDetail.response) }}</pre>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body>
          <b-card-header header-tag="header" class="p-0">
            <b-button block variant="light" class="text-left px-3 py-2 d-flex justify-content-between align-items-center" @click="accordionNotify = !accordionNotify">
              <span>Notify</span>
              <i :class="accordionNotify ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
            </b-button>
          </b-card-header>
          <b-collapse :visible="accordionNotify">
            <b-card-body class="p-3">
              <pre class="mb-0 bg-light rounded p-2" style="font-size: 12px; max-height: 250px; overflow-y: auto; white-space: pre-wrap;">{{ parseJson(selectedDetail.notify) }}</pre>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </b-modal>
    <!-- Pagination -->
    <div v-show="isParams" class="vuetable-pagination ui basic segment grid">
      <div class="wrapper-pagination-custom">
        <div class="pagination-custom-info">
          <p>{{ paginationInfo }}</p>
        </div>
        <div class="pagination-custom-button">
          <button :disabled="current_page === 1" @click="doMovePage('first')">
            <i :class="['fa fa-angle-double-left', current_page === 1 ? 'disabled' : '']"></i>
          </button>
          <button :disabled="current_page === 1" @click="doMovePage('prev')">
            <i :class="['fa fa-angle-left', current_page === 1 ? 'disabled' : '']"></i>
          </button>
          <div>{{ current_page }}</div>
          <button :disabled="current_page >= last_page" @click="doMovePage('next')">
            <i :class="['fa fa-angle-right', current_page >= last_page ? 'disabled' : '']"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import Vuetable from 'vuetable-2/src/components/Vuetable'

Vue.use(Vuetable)

export default {
  components: { Vuetable },
  data() {
    return {
      page: 1,
      current_page: 1,
      limit: 10,
      data: [],
      type: '',
      notifyStartDate: '',
      notifyEndDate: '',
      transactionTypeOptions: [
        { value: '', text: 'Choose type', disabled: true },
        { value: 'all', text: 'All' },
        { value: 'withdraw_sell', text: 'Jual Emas' },
        { value: 'wallet_withdraw_sell', text: 'Tarik Celengan' },
        { value: 'gold_pawn', text: 'Jamimas' },
      ],
      isLoadingTable: false,
      isLoadingButton: false,
      isLoadingDetail: false,
      selectedDetail: {},
      selectedInvoiceNumber: '',
      accordionRequest: true,
      accordionResponse: false,
      accordionNotify: false,
      paginationInfo: '',
      last_page: 1,
      dateRangeState: null,
      dateRangeError: '',
      sort: 'created_at|desc',
      errors: { code: '', message: '', status: '' },
      fields: [
        { name: 'transaction_date-slot', sortField: 'created_at', title: 'Transaction Date' },
        { name: 'transaction_type-slot', sortField: 'transaction_type', title: 'Transaction Type' },
        { name: 'notify_date-slot', sortField: 'notify_date', title: 'Notify Date' },
        { name: 'invoice_number-slot', sortField: 'invoice_number', title: 'Invoice No' },
        { name: 'service-slot', sortField: 'service', title: 'Service' },
        { name: 'status-slot', sortField: 'status', title: 'Status' },
        { name: 'actions-slot', title: 'Actions', titleClass: 'center aligned', dataClass: 'center aligned' }
      ],
      moreParams: {},
      tableCss: {
        ascendingIcon: 'fa fa-sort-asc',
        descendingIcon: 'fa fa-sort-desc',
        sortableIcon: 'fa fa-sort',
      },
      noDataTemplate: '<div class="text-center d-flex align-items-center justify-content-center" style="height: 120px;"><p>Use filter to show your data</p></div>',
      defaultTemplate: '<div class="text-center d-flex align-items-center justify-content-center flex-column" style="height: 120px;"><p><strong>No results found.</strong></p><p>Please adjust your filter</p></div>',
    }
  },
  computed: {
    stateButton() {
      return this.type === '' || this.notifyStartDate === '' || this.dateRangeState === false
    },
    buttonStyle() {
      return {
        background: !this.stateButton ? '#7565F6' : '#c8ced3',
        color: !this.stateButton ? '#FFFFFF' : 'inherit'
      }
    },
    isParams() {
      const isEmpty = Object.entries(this.moreParams).filter(([, value]) => value).length === 0
      return !isEmpty && !this.isLoadingTable
    },
    sortOrder() {
      const [sortField, direction] = this.sort.split('|')
      return [{ field: sortField, sortField, direction }]
    }
  },
  watch: {
    data() {
      if (this.$refs.vuetable && typeof this.$refs.vuetable.refresh === 'function') {
        this.$refs.vuetable.refresh()
      }
    }
  },
  methods: {
    statusColor(status) {
      const map = {
        'On Process': '#FF6900',
        'Success': '#35AA4B',
        'Rejected': '#CB211F',
        'Failed': '#3B353C'
      }
      return map[status] || 'inherit'
    },
    doFilter() {
      this.$events.$emit('apply-filter')
    },
    onFilterSet() {
      this.page = 1
      this.moreParams = {
        transaction_type: this.type,
        notify_date: `${this.notifyStartDate} - ${this.notifyEndDate}`
      }
      this.onFetch()
    },
    onFetch() {
      const newParams = Object.entries(this.moreParams)
        .filter(([, value]) => value !== '' && value != null)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')
      this.isLoadingTable = true
      this.data = []
      this.$http
        .get(`disbursement-log?page=${this.page}&per_page=${this.limit}&sort_by=${this.sort.split('|')[0]}&sort_dir=${this.sort.split('|')[1]}${newParams ? '&' + newParams : ''}`)
        .then(response => {
          const paginate = response.data.data
          const datas = paginate.data
          const startIndex = (paginate.current_page - 1) * this.limit
          const endIndex = Math.min(startIndex + this.limit, startIndex + datas.length)
          this.data = datas
          this.current_page = paginate.current_page
          this.last_page = paginate.last_page
          this.paginationInfo = datas.length > 0
            ? `Displaying ${startIndex + 1} to ${endIndex} of ${paginate.total}`
            : 'No relevant data'
          this.isLoadingTable = false
        })
        .catch(err => {
          this.isLoadingTable = false
          this.handleLoadError(err)
        })
    },
    dataManager(sortOrder, pagination) {
      const local = this.data
      if (local.length < 1) return
      if (sortOrder.length > 0) {
        const newSort = `${sortOrder[0].sortField}|${sortOrder[0].direction}`
        if (this.sort !== newSort) {
          this.sort = newSort
          this.onFetch()
        }
      }
      pagination = this.$refs.vuetable.makePagination(local.length, this.limit)
      const from = pagination.from - 1
      const to = from + this.limit
      return { pagination, data: _.slice(local, from, to) }
    },
    onAction(action, data) {
      if (action === 'detail-item') {
        this.selectedDetail = {}
        this.selectedInvoiceNumber = data.invoice_number || '-'
        this.$bvModal.show('modal-detail-disbursement')
        this.fetchDetail(data.transaction_type, data.invoice_number)
      }
    },
    fetchDetail(transactionType, invoiceNumber) {
      this.isLoadingDetail = true
      this.$http
        .get(`disbursement-log/log?transaction_type=${transactionType}&invoice_number=${invoiceNumber}`)
        .then(response => {
          this.selectedDetail = response.data.data
          this.isLoadingDetail = false
        })
        .catch(err => {
          this.isLoadingDetail = false
          this.handleLoadError(err)
        })
    },
    parseJson(value) {
      if (!value) return '-'
      try {
        return JSON.stringify(JSON.parse(value), null, 2)
      } catch {
        return value
      }
    },
    doNotifyDateFilter(value) {
      this.$events.$emit('notify-date-set', value)
    },
    onNotifyDateSet(value) {
      const startDate = moment(value.startDate)
      let endDate = moment(value.endDate)
      const hoursDiff = endDate.diff(startDate, 'hours', true)
      const yearsDiff = endDate.diff(startDate, 'years', true)

      if (hoursDiff < 1) {
        this.dateRangeState = false
        this.dateRangeError = 'Notify date range must be at least 1 hour'
        return
      }
      if (yearsDiff > 1) {
        endDate = startDate.clone().add(1, 'years')
      }

      this.dateRangeState = null
      this.dateRangeError = ''
      this.notifyStartDate = startDate.format('YYYY-MM-DD HH:mm')
      this.notifyEndDate = endDate.format('YYYY-MM-DD HH:mm')
    },
    resetNotifyDateFilter() {
      this.notifyStartDate = ''
      this.notifyEndDate = ''
      this.dateRangeState = null
      this.dateRangeError = ''
    },
    doMovePage(value) {
      this.$events.$emit('movePage-disbursement', value)
    },
    onMovePage(eventData) {
      if (eventData === 'first') {
        this.page = 1
      } else if (eventData === 'prev') {
        this.page--
      } else {
        this.page++
      }
      this.onFetch()
    },
    handleExport() {
      this.isLoadingButton = true
      const newParams = Object.entries(this.moreParams)
        .filter(([, value]) => value !== '' && value != null)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')
      this.$http
        .get(`disbursement-log-export${newParams ? '?' + newParams : ''}`)
        .then(response => {
          const exportPath = response.data.meta.data
          if (exportPath) {
            window.location.href = exportPath
          }
          this.isLoadingButton = false
        })
        .catch(err => {
          this.isLoadingButton = false
          this.handleLoadError(err)
        })
    },
    handleLoadError(error) {
      if (!error.response) return
      const code = error.response.data.meta.code
      const message = error.response.data.meta.message
      this.errors = { code, message, status: code }
      if (code === 401) {
        this.$swal.fire('Your session expired!', 'Your session has expired. Please login again to access this page!', 'error')
          .then(() => { this.$router.push('/login') })
      } else if (code === 403) {
        this.$router.push('/403')
      } else {
        this.$swal.fire('An error occured', message, 'error')
      }
    }
  },
  created() {
    this.$events.$on('apply-filter', this.onFilterSet)
    this.$events.$on('notify-date-set', this.onNotifyDateSet)
    this.$events.$on('movePage-disbursement', this.onMovePage)
  },
  beforeDestroy() {
    this.$events.$off('apply-filter', this.onFilterSet)
    this.$events.$off('notify-date-set', this.onNotifyDateSet)
    this.$events.$off('movePage-disbursement', this.onMovePage)
  }
}
</script>
<style>
.disbursement-modal-header {
  background-color: #F0F3F5;
}
.wrapper-pagination-custom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9fafb;
}
.pagination-custom-button {
  display: flex;
}
.pagination-custom-button button {
  width: 28px;
  height: 47px;
  padding: 13px 16px;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
}
.pagination-custom-button button:first-child {
  padding: 13px 16px 13px 30px;
  border-radius: 4px 0 0 4px;
  border-width: 1px 0 1px 1px;
}
.pagination-custom-button button:nth-child(2),
.pagination-custom-button button:last-child {
  font-size: 1.3em;
  border-width: 1px;
}
.pagination-custom-button button:last-child {
  border-radius: 0 4px 4px 0;
}
.pagination-custom-button button i.disabled {
  opacity: 0.6;
}
.pagination-custom-button div {
  width: 28px;
  height: 47px;
  font-size: 1em;
  font-weight: 500;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
  border-width: 1px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-loading-bounce {
  width: 72px !important;
  height: 18px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.custom-loading-bounce .sk-child {
  width: 6px !important;
  height: 6px !important;
  background: #ffffff !important;
}
</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
